// src/auth/auth.ts
import axios from 'axios';
import { jwtDecode } from "jwt-decode";

const TOKEN_KEY = 'auth_token';

type JwtPayload = {
  sub: string;
  authorities: string[];
  iat: number;
  exp: number;
};

export function getTokenData(token: string) {
  try {
    const decoded = jwtDecode<JwtPayload>(token);
    return decoded;
  } catch (error) {
    console.error('Invalid token', error);
    return null;
  }
}

export const isTokenExpired = (token: string): boolean => {
  try {
    const decoded = jwtDecode<JwtPayload>(token);
    return decoded.exp * 1000 < Date.now();
  } catch {
    return true;
  }
};

export const saveToken = (token: string) => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const getToken = (): string | undefined => {
  return localStorage.getItem(TOKEN_KEY) ?? undefined;
};

export const clearToken = () => {
  localStorage.removeItem(TOKEN_KEY);
};

// Add token to Axios
axios.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
